import {
  AppBar,
  Button,
  Checkbox,
  DialogContent,
  DialogTitle,
  FormControlLabel,
  Grid,
  Tab,
  Tabs,
} from "@material-ui/core";
import Chip from "@material-ui/core/Chip";
import Slide from "@material-ui/core/Slide";
import { withStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import PropTypes from "prop-types";
import React, { Fragment } from "react";
import { translate } from "react-i18next";
import { connect } from "react-redux";
import validator from "validator";

import { _parsePhoneNumber } from "../../../partials/validateNumber";
import CountryCode from "../../countryCode";
import DialogNotice from "../../dialog";
import Loading from "../../loading";
import PopupInterface from "../../popUpInterface";
import Snackbar from "../../snackbar";
import ListCustomer from "../listCustomer";
import { styles } from "./styles";
import SearchInput from "../../../partials/SearchInput";
import InputForm from "../../../partials/inputForm";
function Transition(props) {
  return <Slide direction="down" {...props} />;
}
class SendVoucher extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      tab: 0,
      countryCode: this.props.defaultCountryCode || "+84",
      dialogOpen: this.props.dialogOpen,
      voucherSend: this.props.voucherSend,
      phoneList: [],
      emailList: [],
      valuePhoneNumber: "",
      valueEmail: "",
      dialog: {
        type: "",
        content: "",
      },
      sendPhoneList: {
        SMS: false,
        Notify: false,
      },
      sendCustomerList: {
        SMS: false,
        Notify: false,
      },
      search: "",
      selectedList: false,
    };
    this.handleDeletePhone = this.handleDeletePhone.bind(this);
    this.handleDeleteEmail = this.handleDeleteEmail.bind(this);
    this.handleCountryCode = this.handleCountryCode.bind(this);
    this.onChangePhoneNumber = this.onChangePhoneNumber.bind(this);
    this.onChangeEmail = this.onChangeEmail.bind(this);
    this.handleSendByPhone = this.handleSendByPhone.bind(this);
    this.handleSendByCustomerList = this.handleSendByCustomerList.bind(this);
  }
  componentWillReceiveProps(nextProps) {
    if (
      nextProps.defaultCountryCode !== this.props.defaultCountryCode &&
      !this.props.defaultCountryCode
    ) {
      this.setState({ countryCode: nextProps.defaultCountryCode });
    }
  }
  onChangeEmail = (e) => {
    let checkEmail = validator.isEmail(e.target.value);
    this.setState({ valueEmail: e.target.value });
  };
  isInPhoneList(countryCode, valuePhoneNumber, phoneList) {
    for (let i = 0; i < phoneList.length; i++) {
      if (
        phoneList[i].countryCode === countryCode &&
        phoneList[i].valuePhoneNumber === valuePhoneNumber
      )
        return true;
    }
    return false;
  }
  onKeyPressPhone = (e) => {
    e.preventDefault();
    let { t } = this.props;
    let _this = this;
    let phoneList = this.state.phoneList;
    let validPhone = _parsePhoneNumber(
      this.state.countryCode,
      this.state.valuePhoneNumber
    ).isValid;
    if (validPhone) {
      let checkExist = this.isInPhoneList(
        this.state.countryCode,
        this.state.valuePhoneNumber,
        this.state.phoneList
      );
      if (checkExist) {
        this.mSnackbar.handleClick(
          t("voucher_uservoucher_phone_number_existed_in_list_selected"),
          "warning"
        );
      } else {
        phoneList.push({
          countryCode: this.state.countryCode,
          valuePhoneNumber: this.state.valuePhoneNumber,
        });
        this.setState({ phoneList }, function () {
          _this.setState({ valuePhoneNumber: "" });
        });
      }
    } else {
      this.mSnackbar.handleClick(
        t("voucher_uservoucher_phone_number_not_valid"),
        "warning"
      );
    }
  };
  onChangePhoneNumber = (e) => {
    this.setState({ valuePhoneNumber: e.target.value });
  };
  handleCountryCode = (name, value) => {
    this.setState({
      countryCode: value,
    });
  };
  handleDeletePhone(phone) {
    let phoneList = this.state.phoneList;
    for (let i = 0; i < phoneList.length; i++) {
      if (
        phoneList[i].countryCode === phone.countryCode &&
        phoneList[i].valuePhoneNumber === phone.valuePhoneNumber
      ) {
        phoneList.splice(i, 1);
        this.setState({ phoneList });
        return;
      }
    }
    return false;
  }
  handleDeleteEmail(email) {
    let emailList = this.state.emailList;
    let index = emailList.indexOf(email);
    if (index > -1) {
      emailList.splice(index, 1);
    }
    this.setState({ emailList });
  }
  handleTab = (event, value) => {
    this.setState({ tab: value });
  };
  componentDidMount = async () => {};
  handleClickOpen = (scroll) => () => {
    this.setState({ open: true, scroll });
  };
  handleClose = (event) => {
    this.setState({ dialogOpen: false });
  };
  handleOpenDialogNotice = (type, content) => {
    let _this = this;
    this.setState(
      {
        dialog: {
          type: type,
          content: content,
        },
      },
      function () {
        _this.mDialog.handleDialogOpen();
      }
    );
  };
  actionDialog = () => {
    let { t } = this.props;
    if (this.state.dialog.type === "phone") {
      if (!this.state.phoneList.length) {
        this.mDialog.handleDialogClose();
        this.mSnackbar.handleClick(
          t("voucher_uservoucher_please_enter_at_least_one_phone_number"),
          "warning"
        );
      } else {
        this.handleSendByPhone();
      }
    } else if (this.state.dialog.type === "customerList") {
      let idList = this.listCustomer.getIdCustomer();
      if (!idList.length) {
        this.mDialog.handleDialogClose();
        this.mSnackbar.handleClick(
          t("voucher_uservoucher_please_select_at_least_one_customer"),
          "warning"
        );
      } else {
        this.mDialog.handleDialogClose();
        this.handleSendByCustomerList();
      }
    }
  };
  handleSendByCustomerList = async () => {
    let { t } = this.props;
    let idList = this.listCustomer.getIdCustomer();
    let _this = this;
    this.mDialog.handleDialogClose();
    this.loading.startLoading();
    let check = await this.props.userVouchersDispatch.checkLimitVoucher();
    this.loading.stopLoading();
    if (check) {
      let statisticsVoucher = this.props.userVouchersState.statisticsVoucher;
      if (
        statisticsVoucher.sentCount + idList.length >
        statisticsVoucher.limit
      ) {
        let maximum =
          Number(statisticsVoucher.limit) - Number(statisticsVoucher.sentCount);
        let content =
          t("voucher_uservoucher_you_exceeded ") +
          statisticsVoucher.limit +
          t(
            "voucher_uservoucher_times_allowed_to_send_vouchers_this_month_you_can_only_send_maximum"
          ) +
          maximum +
          t("voucher_uservoucher_customers_or_please_upgrade_your_package");
        this.setState(
          {
            dialog: {
              type: "upgrade",
              content: content,
            },
          },
          function () {
            _this.mDialogUpgrade.handleDialogOpen();
          }
        );
      } else {
        this.loading.startLoading();
        let check = await this.props.userVouchersDispatch.setVoucherForCustomerList(
          {
            idList: idList,
            voucherSend: this.state.voucherSend,
            methodSend: this.state.sendCustomerList,
          }
        );
        this.loading.stopLoading();
        if (check.code === 1) {
          this.mSnackbar.handleClick(
            t("voucher_uservoucher_send_voucher") +
              " " +
              this.state.voucherSend.code +
              " " +
              t("voucher_uservoucher_successfully")
          );
        } else {
          this.mSnackbar.handleClick(
            t("voucher_uservoucher_send_voucher") +
              " " +
              this.state.voucherSend.code +
              " " +
              t("voucher_uservoucher_unsuccessfully") +
              " " +
              check.message,
            "error"
          );
        }
      }
    } else {
      this.mSnackbar.handleClick(
        t("voucher_uservoucher_system_error_please_try_again"),
        "error"
      );
    }
    this.listCustomer.resetSelected();
  };
  handleSendByPhone = async () => {
    let _this = this;
    let { t } = this.props;
    this.mDialog.handleDialogClose();
    this.loading.startLoading();
    let checkLimitVoucher = await this.props.userVouchersDispatch.checkLimitVoucher();
    if (checkLimitVoucher) {
      let statisticsVoucher = this.props.userVouchersState.statisticsVoucher;
      if (
        statisticsVoucher.sentCount + this.state.phoneList.length >
        statisticsVoucher.limit
      ) {
        this.loading.stopLoading();
        let maximum =
          Number(statisticsVoucher.limit) - Number(statisticsVoucher.sentCount);
        let content =
          t("voucher_uservoucher_you_exceeded ") +
          statisticsVoucher.limit +
          t(
            "voucher_uservoucher_times_allowed_to_send_vouchers_this_month_you_can_only_send_maximum"
          ) +
          maximum +
          t("voucher_uservoucher_mobile_phone_or_please_upgrade_your_package");
        this.setState(
          {
            dialog: {
              type: "upgrade",
              content: content,
            },
          },
          function () {
            _this.mDialogUpgrade.handleDialogOpen();
          }
        );
      } else {
        let check = await this.props.userVouchersDispatch.setVoucherForPhoneList(
          {
            phoneList: this.state.phoneList,
            voucherSend: this.state.voucherSend,
            methodSend: this.state.sendPhoneList,
          }
        );
        this.loading.stopLoading();
        if (check.code === 1) {
          let dataSendPhoneList = this.props.userVouchersState
            .dataSendPhoneList;
          this.mSnackbar.handleClick(
            t("voucher_uservoucher_sent_voucher") +
              " " +
              this.state.voucherSend.code +
              " " +
              t("voucher_uservoucher_successfully")
          );
        } else {
          this.mSnackbar.handleClick(
            t("voucher_uservoucher_send_voucher") +
              " " +
              this.state.voucherSend.code +
              " " +
              t("voucher_uservoucher_unsuccessfully") +
              " " +
              check.message,
            "error"
          );
        }
        this.setState({
          phoneList: [],
        });
      }
    } else {
      this.loading.stopLoading();
      this.mSnackbar.handleClick(
        t("voucher_uservoucher_system_error_please_try_again"),
        "error"
      );
    }
  };
  handleSendByEmail = async () => {};
  onChangeMethodSend = (nameMethod, action) => (event) => {
    let state = this.state;
    state[nameMethod][action] = event.target.checked === true ? 1 : 0;
    this.setState({ state });
  };
  handleSearch = () => {
    let { search } = this.state;
    this.listCustomer.handleSearch(search);
  };
  deleteSearchAndGetList = () => {
    let _this = this;
    this.setState({ search: "" }, function () {
      _this.handleSearch();
    });
  };
  changeSearch = (event) => {
    this.setState({ search: event.target.value });
  };
  selectedList = (status) => {
    this.setState({
      selectedList: status,
    });
  };
  render() {
    const { classes, t } = this.props;
    const { tab, selectedList } = this.state;
    return (
      <PopupInterface
        handleDialogClose={this.props.handleDialogEditClose}
        flagOpen={this.state.dialogOpen}
        onRef={(dialog) => (this.PopUpInterface = dialog)}
      >
        <Loading onRef={(id) => (this.loading = id)} />
        <Snackbar
          color="white"
          onRef={(snackbar) => (this.mSnackbar = snackbar)}
        />
        <DialogNotice
          onRef={(dialog) => (this.mDialog = dialog)}
          disagree={t("voucher_uservoucher_cancel")}
          agree={t("voucher_uservoucher_send")}
          title={t("voucher_uservoucher_notice")}
          content={this.state.dialog.content}
          action={this.actionDialog}
        />
        <DialogNotice
          onRef={(dialog) => (this.mDialogUpgrade = dialog)}
          disagree={t("voucher_uservoucher_cancel")}
          agree={t("voucher_uservoucher_upgrade")}
          title={t("voucher_uservoucher_notice")}
          content={this.state.dialog.content}
          action={this.actionDialog}
        />
        <Fragment>
          <DialogTitle
            id="scroll-dialog-title"
            disableTypography
            style={{ padding: 0 }}
          >
            <Typography variant="h4" className={classes.title}>
              {t("voucher_uservoucher_send_voucher_to_customer")}
            </Typography>
          </DialogTitle>
          <Grid container className={classes.gridContainer}>
            <AppBar position="static" color="default">
              <Tabs
                value={tab}
                onChange={this.handleTab}
                indicatorColor="secondary"
                textColor="secondary"
                classes={{
                  root: classes.tabsRoot,
                  indicator: classes.tabsIndicator,
                }}
                scrollButtons="on"
                variant="scrollable"
              >
                <Tab
                  label={t("voucher_uservoucher_select_by_customer_list")}
                  classes={{
                    root: classes.tabRoot,
                    selected: classes.tabSelected,
                  }}
                />
                <Tab
                  label={t("voucher_uservoucher_select_by_phone_number")}
                  classes={{
                    root: classes.tabRoot,
                    selected: classes.tabSelected,
                  }}
                />
              </Tabs>
            </AppBar>
          </Grid>
          {tab == 0 && (
            <DialogContent className={classes.content}>
              <Grid container spacing={3}>
                <Grid item xs={12} sm={12}>
                  <Grid container spacing={3} className={" tab-profile"}>
                    <Grid item xs={12} sm={12} className={classes.titleFrame}>
                      <div>
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={this.state.sendCustomerList.SMS}
                              onChange={this.onChangeMethodSend(
                                "sendCustomerList",
                                "SMS"
                              )}
                              value="list"
                            />
                          }
                          className={classes.label}
                          label={t("voucher_uservoucher_send_by_sms")}
                        />
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={this.state.sendCustomerList.Notify}
                              onChange={this.onChangeMethodSend(
                                "sendCustomerList",
                                "Notify"
                              )}
                              value="list"
                            />
                          }
                          className={classes.label}
                          label={t("voucher_uservoucher_send_notify_on_app")}
                        />
                      </div>
                      <SearchInput
                        getList={this.handleSearch}
                        onChange={this.changeSearch}
                        value={this.state.search}
                        placeholder={t(
                          "voucher_uservoucher_search_by_name_phone"
                        )}
                        showFilter={false}
                        deleteSearchAndGetList={this.deleteSearchAndGetList}
                      />
                    </Grid>
                    <Grid item xs={12} sm={12}>
                      <ListCustomer
                        onRef={(id) => {
                          this.listCustomer = id;
                        }}
                        listCustomer={this.props.customerState.listCustomer}
                        listBrands={this.props.serviceBranchState.listBrands}
                        selectedList={this.selectedList}
                      />
                    </Grid>
                  </Grid>
                </Grid>
                <Grid item xs={12} sm={12}>
                  <div className={classes.footerList}>
                    <div className={classes.note}>
                      {" "}
                      {t(
                        "voucher_uservoucher_you_can_only_send_maximum_of_100_customers_per_submission_to_send_more_customers_upgrade_your_package_to_premium"
                      )}
                    </div>
                    <Button
                      disabled={selectedList ? false : true}
                      variant="contained"
                      color="primary"
                      className={classes.button}
                      onClick={() =>
                        this.handleOpenDialogNotice(
                          "customerList",
                          t("voucher_uservoucher_do_you_want_to_send_voucher") +
                            " " +
                            this.state.voucherSend.code +
                            " " +
                            t("voucher_uservoucher_to_user")
                        )
                      }
                    >
                      {t("voucher_uservoucher_send")}
                    </Button>
                  </div>
                </Grid>
              </Grid>
            </DialogContent>
          )}
          {tab == 1 && (
            <DialogContent className={classes.content}>
              <Grid container spacing={3}>
                <Grid item xs={12} sm={12}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={this.state.sendPhoneList.SMS}
                        onChange={this.onChangeMethodSend(
                          "sendPhoneList",
                          "SMS"
                        )}
                        value="list"
                      />
                    }
                    className={classes.label}
                    label={t("voucher_uservoucher_send_by_sms")}
                  />
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={this.state.sendPhoneList.Notify}
                        onChange={this.onChangeMethodSend(
                          "sendPhoneList",
                          "Notify"
                        )}
                        value="list"
                      />
                    }
                    className={classes.label}
                    label={t("voucher_uservoucher_send_notify_on_app")}
                  />
                </Grid>
                <form
                  onSubmit={this.onKeyPressPhone}
                  className={classes.containerPhoneInput}
                >
                  <Grid item xs={12} sm={4} className={classes.phoneInput}>
                    <CountryCode
                      code={this.state.countryCode}
                      handleCountryCode={this.handleCountryCode}
                    />
                  </Grid>
                  <Grid item xs={12} sm={8} className={classes.phoneInput}>
                    <InputForm
                      label={t("voucher_uservoucher_type_phone_number")}
                      name="valuePhoneNumber"
                      value={this.state.valuePhoneNumber || ""}
                      onChange={this.onChangePhoneNumber}
                      fullWidth={true}
                    />
                  </Grid>
                </form>
                <Grid item xs={12} sm={12} className={classes.containerButton}>
                  <Button
                    variant="outlined"
                    color="primary"
                    onClick={this.onKeyPressPhone}
                    className={classes.buttonAddPhone}
                  >
                    {t("voucher_uservoucher_button_add")}
                  </Button>
                </Grid>
                <Grid item xs={12} sm={12}>
                  <Typography variant="h6" gutterBottom>
                    {t("voucher_uservoucher_list_selected")}
                  </Typography>
                </Grid>
                {this.state.phoneList.length > 0 && (
                  <Grid item xs={12} sm={12} className={classes.list}>
                    {this.state.phoneList.map((phone, index) => {
                      return (
                        <Chip
                          key={index}
                          label={
                            phone.countryCode + " " + phone.valuePhoneNumber
                          }
                          onDelete={this.handleDeletePhone.bind(this, phone)}
                          className={classes.chip}
                        />
                      );
                    })}
                  </Grid>
                )}
                <Grid item xs={12} sm={12} className={classes.footerList}>
                  <div className={classes.note}>
                    {" "}
                    {t(
                      "voucher_uservoucher_you_can_only_send_maximum_of_100_customers_per_submission_to_send_more_customers_upgrade_your_package_to_premium"
                    )}
                  </div>
                  <Button
                    disabled={this.state.phoneList.length ? false : true}
                    variant="contained"
                    color="primary"
                    className={classes.button}
                    onClick={() =>
                      this.handleOpenDialogNotice(
                        "phone",
                        t("voucher_uservoucher_do_you_want_to_send_voucher") +
                          " " +
                          this.state.voucherSend.code +
                          " " +
                          t("voucher_uservoucher_to_user")
                      )
                    }
                  >
                    {t("voucher_uservoucher_send")}
                  </Button>
                </Grid>
              </Grid>
            </DialogContent>
          )}
        </Fragment>
      </PopupInterface>
    );
  }
}

SendVoucher.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
};
const mapState = (state) => ({
  serviceBranchState: state.serviceBranch,
  customerState: state.customer,
  userVouchersState: state.userVouchers,
  defaultCountryCode: state.setting.setting
    ? state.setting.setting.defaultCountryCode
    : "+84",
});

const mapDispatch = (dispatch) => ({
  userVouchersDispatch: dispatch.userVouchers,
});

export default connect(
  mapState,
  mapDispatch
)(
  translate("translations")(
    withStyles(styles, { withTheme: true })(SendVoucher)
  )
);
// export default SendVoucher
